// @generated by protoc-gen-es-ns v0.0.0 with parameter "target=ts"
// @generated from file kikoff_canada/protobuf/models/onboarding_state.proto (package kikoff_canada.protobuf.models, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { FullName } from "../types/pii/full_name_pb.js";
import { Address } from "../types/pii/address_pb.js";

/**
 * @generated from message kikoff_canada.protobuf.models.OnboardingState
 */
export class OnboardingState extends Message<OnboardingState> {
  /**
   * @generated from field: kikoff_canada.protobuf.models.OnboardingState.NameStep name_step = 1;
   */
  nameStep?: OnboardingState.NameStep;

  /**
   * @generated from field: kikoff_canada.protobuf.models.OnboardingState.PhoneStep phone_step = 2;
   */
  phoneStep?: OnboardingState.PhoneStep;

  /**
   * @generated from field: kikoff_canada.protobuf.models.OnboardingState.BirthDateStep birth_date_step = 3;
   */
  birthDateStep?: OnboardingState.BirthDateStep;

  /**
   * @generated from field: kikoff_canada.protobuf.models.OnboardingState.AddressStep address_step = 4;
   */
  addressStep?: OnboardingState.AddressStep;

  /**
   * @generated from field: google.protobuf.Timestamp completed_at = 5;
   */
  completedAt?: Timestamp;

  /**
   * @generated from field: kikoff_canada.protobuf.models.OnboardingState.CompletionStatus completion_status = 6;
   */
  completionStatus = OnboardingState.CompletionStatus.UNKNOWN;

  constructor(data?: PartialMessage<OnboardingState>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "kikoff_canada.protobuf.models.OnboardingState";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name_step", kind: "message", T: OnboardingState.NameStep },
    { no: 2, name: "phone_step", kind: "message", T: OnboardingState.PhoneStep },
    { no: 3, name: "birth_date_step", kind: "message", T: OnboardingState.BirthDateStep },
    { no: 4, name: "address_step", kind: "message", T: OnboardingState.AddressStep },
    { no: 5, name: "completed_at", kind: "message", T: Timestamp },
    { no: 6, name: "completion_status", kind: "enum", T: proto3.getEnumType(OnboardingState.CompletionStatus) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OnboardingState {
    return new OnboardingState().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OnboardingState {
    return new OnboardingState().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OnboardingState {
    return new OnboardingState().fromJsonString(jsonString, options);
  }

  static equals(a: OnboardingState | PlainMessage<OnboardingState> | undefined, b: OnboardingState | PlainMessage<OnboardingState> | undefined): boolean {
    return proto3.util.equals(OnboardingState, a, b);
  }

  static _enums: {
    CompletionStatus: typeof OnboardingState.CompletionStatus,
  };
}

export namespace OnboardingState {
  /**
   * @generated from enum kikoff_canada.protobuf.models.OnboardingState.CompletionStatus
   */
  export enum CompletionStatus {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: INELIGIBLE_SUBDIVISION = 1;
     */
    INELIGIBLE_SUBDIVISION = 1,

    /**
     * @generated from enum value: RISK_PASSED = 2;
     */
    RISK_PASSED = 2,

    /**
     * @generated from enum value: RISK_RETRY = 3;
     */
    RISK_RETRY = 3,

    /**
     * @generated from enum value: RISK_FLAGGED = 4;
     */
    RISK_FLAGGED = 4,

    /**
     * @generated from enum value: RISK_CHECKING = 5;
     */
    RISK_CHECKING = 5,

    /**
     * @generated from enum value: MANUAL_IDV_NEEDED = 6;
     */
    MANUAL_IDV_NEEDED = 6,

    /**
     * @generated from enum value: MANUAL_IDV_NEEDS_REVIEW = 7;
     */
    MANUAL_IDV_NEEDS_REVIEW = 7,

    /**
     * @generated from enum value: MANUAL_IDV_NEEDS_REUPLOAD = 8;
     */
    MANUAL_IDV_NEEDS_REUPLOAD = 8,

    /**
     * @generated from enum value: MANUAL_IDV_FAILED = 9;
     */
    MANUAL_IDV_FAILED = 9,
  }
  // Retrieve enum metadata with: proto3.getEnumType(OnboardingState.CompletionStatus)
  proto3.util.setEnumType(OnboardingState.CompletionStatus, "kikoff_canada.protobuf.models.OnboardingState.CompletionStatus", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "INELIGIBLE_SUBDIVISION" },
    { no: 2, name: "RISK_PASSED" },
    { no: 3, name: "RISK_RETRY" },
    { no: 4, name: "RISK_FLAGGED" },
    { no: 5, name: "RISK_CHECKING" },
    { no: 6, name: "MANUAL_IDV_NEEDED" },
    { no: 7, name: "MANUAL_IDV_NEEDS_REVIEW" },
    { no: 8, name: "MANUAL_IDV_NEEDS_REUPLOAD" },
    { no: 9, name: "MANUAL_IDV_FAILED" },
  ]);
}

export namespace OnboardingState {
  /**
   * @generated from message kikoff_canada.protobuf.models.OnboardingState.NameStep
   */
  export class NameStep extends Message<OnboardingState.NameStep> {
    /**
     * @generated from field: bool completed = 1;
     */
    completed = false;

    /**
     * @generated from field: kikoff_canada.protobuf.types.pii.FullName full_name = 2;
     */
    fullName?: FullName;

    constructor(data?: PartialMessage<OnboardingState.NameStep>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "kikoff_canada.protobuf.models.OnboardingState.NameStep";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "completed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
      { no: 2, name: "full_name", kind: "message", T: FullName },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OnboardingState.NameStep {
      return new OnboardingState.NameStep().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OnboardingState.NameStep {
      return new OnboardingState.NameStep().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OnboardingState.NameStep {
      return new OnboardingState.NameStep().fromJsonString(jsonString, options);
    }

    static equals(a: OnboardingState.NameStep | PlainMessage<OnboardingState.NameStep> | undefined, b: OnboardingState.NameStep | PlainMessage<OnboardingState.NameStep> | undefined): boolean {
      return proto3.util.equals(OnboardingState.NameStep, a, b);
    }

    static _enums: {
    };
  }
}

export namespace OnboardingState {
  /**
   * @generated from message kikoff_canada.protobuf.models.OnboardingState.PhoneStep
   */
  export class PhoneStep extends Message<OnboardingState.PhoneStep> {
    /**
     * @generated from field: bool completed = 1;
     */
    completed = false;

    /**
     * @generated from field: string phone = 2;
     */
    phone = "";

    constructor(data?: PartialMessage<OnboardingState.PhoneStep>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "kikoff_canada.protobuf.models.OnboardingState.PhoneStep";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "completed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
      { no: 2, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OnboardingState.PhoneStep {
      return new OnboardingState.PhoneStep().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OnboardingState.PhoneStep {
      return new OnboardingState.PhoneStep().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OnboardingState.PhoneStep {
      return new OnboardingState.PhoneStep().fromJsonString(jsonString, options);
    }

    static equals(a: OnboardingState.PhoneStep | PlainMessage<OnboardingState.PhoneStep> | undefined, b: OnboardingState.PhoneStep | PlainMessage<OnboardingState.PhoneStep> | undefined): boolean {
      return proto3.util.equals(OnboardingState.PhoneStep, a, b);
    }

    static _enums: {
    };
  }
}

export namespace OnboardingState {
  /**
   * @generated from message kikoff_canada.protobuf.models.OnboardingState.BirthDateStep
   */
  export class BirthDateStep extends Message<OnboardingState.BirthDateStep> {
    /**
     * @generated from field: bool completed = 1;
     */
    completed = false;

    /**
     * @generated from field: string birth_date = 2;
     */
    birthDate = "";

    constructor(data?: PartialMessage<OnboardingState.BirthDateStep>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "kikoff_canada.protobuf.models.OnboardingState.BirthDateStep";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "completed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
      { no: 2, name: "birth_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OnboardingState.BirthDateStep {
      return new OnboardingState.BirthDateStep().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OnboardingState.BirthDateStep {
      return new OnboardingState.BirthDateStep().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OnboardingState.BirthDateStep {
      return new OnboardingState.BirthDateStep().fromJsonString(jsonString, options);
    }

    static equals(a: OnboardingState.BirthDateStep | PlainMessage<OnboardingState.BirthDateStep> | undefined, b: OnboardingState.BirthDateStep | PlainMessage<OnboardingState.BirthDateStep> | undefined): boolean {
      return proto3.util.equals(OnboardingState.BirthDateStep, a, b);
    }

    static _enums: {
    };
  }
}

export namespace OnboardingState {
  /**
   * @generated from message kikoff_canada.protobuf.models.OnboardingState.AddressStep
   */
  export class AddressStep extends Message<OnboardingState.AddressStep> {
    /**
     * @generated from field: bool completed = 1;
     */
    completed = false;

    /**
     * @generated from field: kikoff_canada.protobuf.types.pii.Address address = 2;
     */
    address?: Address;

    constructor(data?: PartialMessage<OnboardingState.AddressStep>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "kikoff_canada.protobuf.models.OnboardingState.AddressStep";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "completed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
      { no: 2, name: "address", kind: "message", T: Address },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OnboardingState.AddressStep {
      return new OnboardingState.AddressStep().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OnboardingState.AddressStep {
      return new OnboardingState.AddressStep().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OnboardingState.AddressStep {
      return new OnboardingState.AddressStep().fromJsonString(jsonString, options);
    }

    static equals(a: OnboardingState.AddressStep | PlainMessage<OnboardingState.AddressStep> | undefined, b: OnboardingState.AddressStep | PlainMessage<OnboardingState.AddressStep> | undefined): boolean {
      return proto3.util.equals(OnboardingState.AddressStep, a, b);
    }

    static _enums: {
    };
  }
}

